import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";

const KontakAdd = () => {
    const [formData, setFormData] = useState({
        email: "",
        alamat: "",
        jamkerja: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/kontak/createKontak`,
                formData
            );
            if (response.status === 201) {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Contact information successfully added!",
                });
                setFormData({ email: "", alamat: "", jamkerja: "" }); // Reset form
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong, please try again.",
                });
            }
        } catch (error) {
            console.error("Error adding contact information:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Error adding contact information.",
            });
        }
    };

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Tambah Kontak</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">Tambah Kontak</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title">Form Tambah Kontak</h3>
                                    </div>
                                    <form onSubmit={handleSubmit} className="kontak-add-form">
                                        <div className="card-body">
                                            <div className="form-group">
                                                <label htmlFor="email">Email</label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    className="form-control"
                                                    id="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="alamat">Alamat</label>
                                                <textarea
                                                    name="alamat"
                                                    className="form-control"
                                                    id="alamat"
                                                    rows="3"
                                                    value={formData.alamat}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="jamkerja">Jam Kerja</label>
                                                <input
                                                    type="text"
                                                    name="jamkerja"
                                                    className="form-control"
                                                    id="jamkerja"
                                                    value={formData.jamkerja}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="card-footer text-center">
                                            <button type="submit" className="btn btn-primary">
                                                Tambah Kontak
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default KontakAdd;
